<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <el-row type="flex" justify="center">
      <lz-form ref="form" :get-data="getData" :submit="onSubmit" :form.sync="form" :errors.sync="errors" :edit-mode="editMode">
        <el-form-item label="通知类型" required prop="notify_types">
          <el-select v-model="form.notify_types" multiple placeholder="请选择">
            <el-option v-for="item in notifyTypeOptions" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.remark" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="form.status" active-text="启用" inactive-text="禁用" />
        </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import {
  getNotifyTypes,
  editWechatNotifyBind,
  updateWechatNotifyBind,
  storeWechatNotifyBind,
  createWechatNotifyBind,
} from '@/api/wechat-notify-binds'
import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
  },
  mixins: [FormHelper],
  data() {
    return {
      form: {
        notify_types: '',
        remark: '',
        status: false,
      },
      errors: {},

      notifyTypeOptions: [],
    }
  },
  created() {
    this.getNotifyTypes()
  },

  methods: {
    async getNotifyTypes() {
      const { data } = await getNotifyTypes()
      this.notifyTypeOptions = data
    },
    async getData() {
      let data

      if (this.editMode) {
        ;({ data } = await editWechatNotifyBind(this.resourceId))
        this.fillForm(data)
      } else {
        ;({ data } = await createWechatNotifyBind())
      }
    },
    async onSubmit() {
      if (this.editMode) {
        await updateWechatNotifyBind(this.resourceId, this.form)
      } else {
        await storeWechatNotifyBind(this.form)
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
